export enum DestinationType {
    ALL = 1,
    GROUPS = 2,
    CONNECTED_USERS = 3,
    NOT_CONNECTED_USERS = 4,
    SPECIFIC = 5
}